export interface AddToWishlistDto
{
    getIdentifier(): string;
    getMsisdn(): string;
    getContentId(): string;
    getContentName(): string;
    getPath(): string;
    getPreviewImage(): string;
    getAlbum(): string;
    getArtist(): string;
    getPrice(): string;
    getLanguage(): string;
    getWishlistType(): string;
}

export class AddToWishlistDtoImpl implements AddToWishlistDto
{
    private identifier: string;
    private msisdn: string;
    private contentId: string;
    private contentName: string;
    private path: string;
    private previewImage: string;
    private album: string;
    private artist: string;
    private price: string;
    private language: string;
    private wishlistType: string;

    getIdentifier(): string 
    {
        return this.identifier;
    }
    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getContentId(): string 
    {
        return this.contentId;
    }
    setContentId(contentId: string)
    {
        this.contentId = contentId;
    }

    getContentName(): string 
    {
        return this.contentName;
    }
    setContentName(contentName: string)
    {
        this.contentName = contentName;
    }

    getPath(): string 
    {
        return this.path;
    }
    setPath(path: string)
    {
        this.path = path;
    }

    getPreviewImage(): string 
    {
        return this.previewImage;
    }
    setPreviewImage(previewImage: string)
    {
        this.previewImage = previewImage;
    }

    getAlbum(): string 
    {
        return this.album;
    }
    setAlbum(album: string)
    {
        this.album = album;
    }

    getArtist(): string 
    {
        return this.artist;
    }
    setArtist(artist: string)
    {
        this.artist = artist;
    }

    getPrice(): string 
    {
        return this.price;
    }
    setPrice(price: string)
    {
        this.price = price;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getWishlistType(): string 
    {
        return this.wishlistType;
    }
    setWishlistType(wishlistType: string)
    {
        this.wishlistType = wishlistType;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/wishlist/addtowishlist/addtowishlistdto.tsx